import cs from '../translations/cs.js'
import sk from '../translations/sk.js'
import si from '../translations/si.js'
import hu from '../translations/hu.js'
import hr from '../translations/hr.js'

const languages = {
    cs,
    si,
    sk,
    hu,
    hr,
}

// Získáme aktuální jazyk z data layer

const currentLanguage = typeof editorLang !== 'undefined' ? editorLang : getShoptetDataLayer('language')

// Funkce pro překlad klíčů
export function _t(key) {
    // Získáme překlad pro daný klíč a aktuální jazyk
    const translation = languages[currentLanguage][key]
    // Pokud překlad neexistuje, vypíšeme chybu do konzole a vrátíme původní klíč
    if (!translation) {
        console.error(`Překlad '${key}' nebyl nalezen pro jazyk '${currentLanguage}'`)
        return key
    }

    return translation
}

export function createCustomSwiper(element, options = {}) {
    const {
        swiperClass,
        swiperChildrenClass = '',
        pagination = false,
        arrows = true,
        arrowsOutside = false,
        customOptions = {},
    } = options

    const targetElement = document.querySelector(element)

    if (!targetElement) return

    const childrenHTML = Array.from(targetElement.children)
        .map(
            (child) => /*HTML*/ `
          <div class="swiper-slide ${swiperChildrenClass}">
            ${child.innerHTML
                .replace(
                    /<span class="extended-banner-texts">/g,
                    '<div class="extended-banner-wrapper"><span class="extended-banner-texts">'
                )
                .replace(/<\/span>(?=<\/a>)/g, '</span></div>')}
          </div>
          `
        )
        .join('')

    const swiperHTML = /* HTML */ `
        <div class="swiper custom-swiper ${swiperClass}">
            <div class="swiper-wrapper">${childrenHTML}</div>
            ${pagination
                ? /* HTML */ `
                      <div class="swiper-pagination-wrapper">
                          <div class="swiper-pagination ${swiperClass}-pagination"></div>
                      </div>
                  `
                : ''}
        </div>
        ${arrows
            ? /* HTML */ `
                  <div class="swiper-navigation ${swiperClass}-navigation">
                      <div class="swiper-button-prev ${swiperClass}-button-prev"></div>
                      <div class="swiper-button-next ${swiperClass}-button-next"></div>
                  </div>
              `
            : ''}
    `

    targetElement.insertAdjacentHTML('afterend', swiperHTML)
    targetElement.classList.add('hide')

    const defaultOptions = {
        slidesPerView: 1.2,
        loop: true,
        spaceBetween: 18,
        pagination: pagination
            ? {
                  el: `.${swiperClass}-pagination`,
                  clickable: true,
              }
            : false,
        navigation: arrows
            ? {
                  nextEl: `.${swiperClass}-button-next`,
                  prevEl: `.${swiperClass}-button-prev`,
              }
            : false,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1335: {
                slidesPerView: 4,
            },
        },
    }

    new Swiper(`.${swiperClass}`, { ...defaultOptions, ...customOptions })
}

function createSwiperContainer(index) {
    return /* HTML */ `
        <div class="swiper-products-container section-${index}">
            <div class="swiper swiper-products-tab">
                <div class="swiper-wrapper products-block"></div>
            </div>
            <div class="swiper-navigation">
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    `
}

export function createSwiperProductBlocks(selector = '.products-wrapper') {
    const isAdvancedOrder = document.querySelector('.advanced-order')
    $(selector).each(function (i) {
        const wrapper = $(this)

        wrapper.after(createSwiperContainer(i))

        const addedProductIds = []

        wrapper.find('.product').each(function () {
            const product = $(this)
            const productId = product.find('.p').attr('data-micro-product-id')

            if (!addedProductIds.includes(productId)) {
                const clonedProduct = product
                    .clone()
                    .attr('class', 'product swiper-slide')
                    .removeAttr('style')

                addedProductIds.push(productId)

                $(`.swiper-products-container.section-${i}`)
                    .find('.swiper-wrapper.products-block')
                    .append(clonedProduct)
            }
        })

        const numberOfSlides = addedProductIds.length

        const slides = numberOfSlides <= 5 ? 5 : 5.5

        if (numberOfSlides <= 5 && $(window).width() >= 1251) {
            const currentSwiperSection = $(`.swiper-products-container.section-${i}`)
            const numOfCurrentSwiperSlides = currentSwiperSection.find('.swiper-slide').length

            if (numOfCurrentSwiperSlides <= 5) {
                currentSwiperSection.addClass('hide-navigation')
            }
        }

        wrapper.addClass('hide')

        new Swiper(`.section-${i} .swiper-products-tab`, {
            slidesPerView: 2.3,
            navigation: {
                nextEl: `.section-${i} .swiper-button-next`,
                prevEl: `.section-${i} .swiper-button-prev`,
            },
            spaceBetween: 12,
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 3.5,
                },
                1250: {
                    slidesPerView: 4.5,
                },
                1520: {
                    slidesPerView: isAdvancedOrder ? 4.5 : slides,
                },
            },
        })
    })
}

export function isMobile() {
    return $(window).width() <= 767
}

export function getElementHeight(selector) {
    const element = $(selector)
    return element.is(':visible') ? element.outerHeight() : 0
}
